var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file TransferList
 * @author zhuwanying02, zhanghao14
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isArray, isFunction, isEqual, cloneDeep } from 'lodash-es';
import classnames from 'classnames';

import { Checkbox } from '../Checkbox';
import { classPrefix } from '../../common/util';

import TransferHeader from './TransferHeader';
import Search from '../Search';

import './Transfer.less';

var TransferList = function (_Component) {
    _inherits(TransferList, _Component);

    function TransferList(props) {
        _classCallCheck(this, TransferList);

        var _this = _possibleConstructorReturn(this, (TransferList.__proto__ || Object.getPrototypeOf(TransferList)).call(this, props));

        _initialiseProps.call(_this);

        var dataSource = props.dataSource,
            selectedIds = props.selectedIds,
            searchValue = props.searchValue;

        _this.FULL_SELECTED = true; // 全选
        _this.HALF_SELECTED = -1; // 半选
        _this.EMPTY_SELECTED = false; // 全不选

        _this.state = {
            isShowClearIcon: !!searchValue,
            isSelectAll: _this.isSelectAll(dataSource, selectedIds)
        };
        return _this;
    }

    _createClass(TransferList, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var dataSource = nextProps.dataSource,
                selectedIds = nextProps.selectedIds,
                searchValue = nextProps.searchValue;

            if (!isEqual(this.props.dataSource, dataSource) || !isEqual(this.props.selectedIds, selectedIds) || !isEqual(this.props.searchValue, searchValue)) {
                this.setState({
                    isShowClearIcon: !!searchValue,
                    isSelectAll: this.isSelectAll(dataSource, selectedIds)
                });
            }
        }
    }, {
        key: 'isSelectAll',
        value: function isSelectAll(dataSource, selectedIds) {
            if (!dataSource || !isArray(dataSource) || dataSource.length === 0) {
                return this.EMPTY_SELECTED;
            }
            var selectedArr = dataSource.filter(function (item) {
                return selectedIds.indexOf(item.id) > -1;
            });
            if (selectedArr.length > 0) {
                if (selectedArr.length === dataSource.length) {
                    return this.FULL_SELECTED;
                }
                return this.HALF_SELECTED;
            }
            return this.EMPTY_SELECTED;
        }
    }, {
        key: 'changeSelectItem',
        value: function changeSelectItem(id, data) {
            var _props = this.props,
                selectedIds = _props.selectedIds,
                role = _props.role,
                onSelectChange = _props.onSelectChange;

            var index = selectedIds.indexOf(id);
            var newSelectedIds = cloneDeep(selectedIds);
            if (data.checked) {
                if (index === -1) {
                    newSelectedIds.push(id);
                }
            } else if (index > -1) {
                newSelectedIds.splice(index, 1);
            }

            if (onSelectChange && isFunction(onSelectChange)) {
                onSelectChange({ role: role, newSelectedIds: newSelectedIds });
            }
        }
    }, {
        key: 'getFilterData',
        value: function getFilterData(dataSource, searchValue) {
            var isShowSearch = this.props.isShowSearch;
            var searchedData = dataSource.slice(0);
            if (isShowSearch) {
                searchedData = dataSource.filter(function (item) {
                    return item.title.indexOf(searchValue) > -1;
                });
            }
            return searchedData;
        }
    }, {
        key: 'renderTransferItem',
        value: function renderTransferItem() {
            var _this2 = this;

            var _props2 = this.props,
                classPrefix = _props2.classPrefix,
                emptyLabel = _props2.emptyLabel,
                dataSource = _props2.dataSource,
                selectedIds = _props2.selectedIds,
                searchValue = _props2.searchValue;

            var searchedData = this.getFilterData(dataSource, searchValue);

            if (!searchedData || !isArray(searchedData) || searchedData.length === 0) {
                return React.createElement(
                    'li',
                    { className: 'no-data' },
                    emptyLabel || '暂无内容'
                );
            }
            var itemNormalClass = classPrefix + '-transfer-list-content-item';
            var checkboxClass = itemNormalClass + '-checkbox';
            return searchedData.map(function (item) {
                var _classnames;

                var checked = selectedIds.indexOf(item.id) > -1;
                var itemClass = classnames((_classnames = {}, _defineProperty(_classnames, itemNormalClass, true), _defineProperty(_classnames, itemNormalClass + '-disabled', item.disabled), _classnames));
                return React.createElement(
                    'li',
                    { key: item.id, className: itemClass },
                    React.createElement(
                        Checkbox,
                        {
                            className: checkboxClass,
                            checked: checked,
                            disabled: item.disabled,
                            getValue: _this2.changeSelectItem.bind(_this2, item.id)
                        },
                        item.title
                    )
                );
            });
        }
    }, {
        key: 'renderSearch',
        value: function renderSearch() {
            var _classnames2;

            var _props3 = this.props,
                width = _props3.width,
                classPrefix = _props3.classPrefix,
                searchValue = _props3.searchValue;

            var isShowClearIcon = this.state.isShowClearIcon;
            var searchBoxClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-transfer-search', true), _defineProperty(_classnames2, classPrefix + '-transfer-search-with-clear', isShowClearIcon), _classnames2));
            var searchBoxStyle = { width: width };
            return React.createElement(
                'div',
                { className: searchBoxClass, style: searchBoxStyle },
                React.createElement(Search, {
                    nowarning: true,
                    value: searchValue,
                    getValue: this.onSearchChange,
                    iconClick: this.iconClick,
                    isShowClearIcon: true
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props4 = this.props,
                classPrefix = _props4.classPrefix,
                width = _props4.width,
                dataSource = _props4.dataSource,
                title = _props4.title,
                isShowSearch = _props4.isShowSearch,
                selectedIds = _props4.selectedIds;

            var prefixCls = classPrefix + '-transfer-list';
            var rootStyle = { width: width };
            var isSelectAll = this.state.isSelectAll;
            return React.createElement(
                'div',
                { className: prefixCls, style: rootStyle },
                React.createElement(TransferHeader, {
                    classPrefix: classPrefix,
                    title: title,
                    dataSourceLength: dataSource.length,
                    selectedIdsLength: selectedIds.length,
                    isSelectAll: isSelectAll,
                    toggleSelectAll: this.toggleSelectAll
                }),
                isShowSearch && this.renderSearch(),
                React.createElement(
                    'ul',
                    { className: prefixCls + '-content' },
                    this.renderTransferItem()
                )
            );
        }
    }]);

    return TransferList;
}(Component);

TransferList.defaultProps = {
    classPrefix: classPrefix,
    searchValue: '',
    width: 240
};
TransferList.propTypes = {
    classPrefix: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    dataSource: PropTypes.array,
    selectedIds: PropTypes.array,
    searchValue: PropTypes.string,
    role: PropTypes.string,
    onSelectChange: PropTypes.func,
    onSearchChange: PropTypes.func,
    emptyLabel: PropTypes.node,
    title: PropTypes.node,
    isShowSearch: PropTypes.bool
};

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.toggleSelectAll = function () {
        var _props5 = _this3.props,
            role = _props5.role,
            onSelectChange = _props5.onSelectChange,
            dataSource = _props5.dataSource,
            selectedIds = _props5.selectedIds;

        var isSelectAll = _this3.state.isSelectAll;
        var validDataSource = dataSource.filter(function (item) {
            return !item.disabled;
        });
        var newSelectedIds = [];
        if (isSelectAll === _this3.HALF_SELECTED) {
            if (selectedIds.length === validDataSource.length) {
                // full-selected without disabled item
                newSelectedIds = [];
            } else {
                validDataSource.forEach(function (item) {
                    newSelectedIds.push(item.id);
                });
            }
        } else if (isSelectAll === _this3.FULL_SELECTED) {
            newSelectedIds = [];
        } else if (isSelectAll === _this3.EMPTY_SELECTED) {
            validDataSource.forEach(function (item) {
                newSelectedIds.push(item.id);
            });
        }

        if (onSelectChange && isFunction(onSelectChange)) {
            onSelectChange({ role: role, newSelectedIds: newSelectedIds });
        }
    };

    this.onSearchChange = function (data) {
        var _props6 = _this3.props,
            role = _props6.role,
            onSearchChange = _props6.onSearchChange;

        if (onSearchChange && isFunction(onSearchChange)) {
            onSearchChange({ role: role, value: data.value });
        }
    };

    this.iconClick = function () {
        var _props7 = _this3.props,
            role = _props7.role,
            onSearchChange = _props7.onSearchChange;

        if (onSearchChange && isFunction(onSearchChange)) {
            onSearchChange({ role: role, value: '' });
        }
    };
};

export default TransferList;